import { seoLinkImages } from '../mortgage-assets';

export interface ISeoLinkItem {
  title: string;
  href: string;
  image: {
    light: string;
    dark: string;
  };
}

export const seoLinks: ISeoLinkItem[] = [
  {
    title: 'Ипотека на ваших условиях',
    href: '/ipoteka/calculator?banner=new-header-ipoteka-calc',
    image: seoLinkImages.calc,
  },
  {
    title: 'Господдержка для семей',
    href: '/ipoteka/s-gospodderzhkoj/',
    image: seoLinkImages.pony,
  },
  {
    title: 'Ипотека на дома и строительство',
    href: '/ipoteka-suburban/',
    image: seoLinkImages.house,
  },
  {
    title: 'Скидки на ипотеку от застройщиков',
    href: '/skidki-i-akcii/',
    image: seoLinkImages.discount,
  },
];
